module.exports = __webpack_public_path__ + "static/LASSO-6f0ff2a92167f56e3a5b02e36afcae5a.jpg";